module.exports = __webpack_public_path__ + "img/pdf_icon.4909e632.png";